import { Component, OnInit, Renderer2, AfterViewInit, Inject, inject } from '@angular/core';

import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

interface HubSpotFormOptions {
  portalId: string;
  formId: string;
  region: string;
  target?: string;
  onFormReady?: (form: any) => void;
}

declare global {
  interface Window {
    hbspt?: {
      forms: {
        create(options: HubSpotFormOptions): void;
      };
    };
  }
}

const HUBSPOT_SETTINGS = {
  portalId: '20357418',
  formId: '5502e58e-c482-42be-b4d7-48dd8cecb01f',
  region: 'na1',
};

export interface HubSpotFormData {
  firstName?: string;
  lastName?: string;
  email?: string;
}

@Component({
  selector: 'app-cs-ticket-dialog',
  standalone: true,
  imports: [MatDialogModule, MatIconModule],
  templateUrl: './cs-ticket-dialog.component.html',
  styleUrl: './cs-ticket-dialog.component.scss',
})
export class CsTicketDialogComponent implements OnInit, AfterViewInit {
  private hubspotScriptLoaded = false;
  private renderer = inject(Renderer2);
  private dialogRef = inject(MatDialogRef<CsTicketDialogComponent>);
  private data: HubSpotFormData | null = inject(MAT_DIALOG_DATA) as HubSpotFormData;

  constructor() {}

  ngOnInit(): void {
    this.loadHubSpotScript();
  }

  ngAfterViewInit(): void {
    // If script is already loaded, create form immediately
    if (window.hbspt) {
      this.createHubSpotForm();
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }

  private loadHubSpotScript(): void {
    if (window.hbspt) {
      // Script already loaded
      return;
    }

    if (this.hubspotScriptLoaded) {
      return;
    }

    this.hubspotScriptLoaded = true;
    const script = this.renderer.createElement('script');
    script.type = 'text/javascript';
    script.src = '//js.hsforms.net/forms/embed/v2.js';
    script.charset = 'utf-8';
    script.onload = () => {
      this.createHubSpotForm();
    };
    this.renderer.appendChild(document.body, script);
  }

  private createHubSpotForm(): void {
    if (window.hbspt) {
      const formOptions: HubSpotFormOptions = {
        portalId: HUBSPOT_SETTINGS.portalId,
        formId: HUBSPOT_SETTINGS.formId,
        region: HUBSPOT_SETTINGS.region,
        target: '#cs-ticket-hubspot-form-container',
        onFormReady: (form: any) => {
          const firstname = form.querySelector('input[name="firstname"]') as HTMLInputElement;
          const lastname = form.querySelector('input[name="lastname"]') as HTMLInputElement;
          const email = form.querySelector('input[name="email"]') as HTMLInputElement;
          firstname.value = this.data?.firstName ?? '';
          lastname.value = this.data?.lastName ?? '';
          email.value = this.data?.email ?? '';
          firstname.dispatchEvent(new Event('input', { bubbles: true }));
          lastname.dispatchEvent(new Event('input', { bubbles: true }));
          email.dispatchEvent(new Event('input', { bubbles: true }));
        },
      };

      window.hbspt.forms.create(formOptions);
    }
  }
}
